<template>
	<modal name="membership" :width="300" height="auto" @before-open="handleBeforeOpen">
		<div id="membership-modal">
			<h1>{{ $t('membershipModal.title') }}</h1>
			<IconTimes class="close-modal" @click.native="$modal.hide('membership')" />

			<template v-if="!isMembership">
				<p><strong>{{ $t('membershipModal.noMembership') }}</strong></p>

				<template v-if="!discount">
					<p>{{ $t('membershipModal.noMembershipText1') }}</p>
					<p>{{ $t('membershipModal.noMembershipText2') }}</p>
				</template>

				<button type="button" class="payment-button" @click="openPayment"><strong style="font-weight: 700">{{ $t('membershipModal.membershipButton') }}</strong> ({{ $t('membershipModal.price', { price: this.price }) }})</button>

				<p v-html="$t('membershipModal.moreOnWebsite')"></p>

				<template v-if="$i18n.locale === 'cs'">
					<div class="discount-input" v-if="discount === null">
						<p>Máš-li slevový kód, zadej ho do políčka níže a klikni na "Uplatnit".</p>
						<MangoButtonedInput v-model="discountCode"
											button-title="Uplatnit" @submit="useDiscount" />
					</div>
					<div class="discount" v-if="discount !== null">
						<p>
							<strong>Je nastavena sleva {{ discount.percent }} %.</strong>
							Slevový kód brzy vyprší, pro aktivaci členství klikněte na tlačítko "<strong>Předplatit</strong>".
						</p>
						<p>Sleva bude platit {{ discount.months }} měsíců. Poté bude automaticky nastavena na standardní cenu {{ originalPrice }} Kč / měsíc.</p>
						<p>Členství je možné kdykoliv ukončit.</p>
					</div>
				</template>
			</template>
			<template v-if="isMembership">
				<p><strong style="font-weight: 700">{{ $t('membershipModal.yourMembershipExpire') }} {{ datetimeMembershipExpire|formatDate }}.</strong></p>
				<p v-if="!isMembershipCancelled"><strong style="color: #ffdd80">{{ $t('membershipModal.yourMembershipResumption1') }} {{ datetimeMembershipExpire|formatDate }} {{ $t('membershipModal.yourMembershipResumption2') }}</strong></p>
				<p v-if="isMembershipCancelled"><strong style="color: #ffdd80">{{ $t('membershipModal.yourMembershipCancelled1') }} {{ datetimeMembershipExpire|formatDate }} {{ $t('membershipModal.yourMembershipCancelled2') }}</strong></p>
				<p>{{ $t('membershipModal.thanksForSupport') }}</p>
				<p>{{ $t('membershipModal.support') }} <a href="mailto:adam@motvicka.cz">adam@motvicka.cz</a>.</p>

				<template v-if="!isMembershipCancelled">
					<button type="button" class="cancel-membership-button" @click="cancelMembership">{{ $t('membershipModal.cancelMembershipButton') }}</button>
				</template>
			</template>
		</div>
	</modal>
</template>

<script>
	import { mapState } from "vuex";
	import IconTimes from "@/components/icons/IconTimes";
	import {MembershipMixin} from "../../mixins/MembershipMixin";
	import firebase from "firebase";
	import { Browser } from "@capacitor/browser";
	import MangoButtonedInput from "@/components/buttoned-input/MangoButtonedInput";

	export default {
		mixins: [ MembershipMixin ],
		data() {
			return {
				discountCode: "",
				discount: null,
				originalPrice: 0,
				price: 0
			}
		},
		components: {
			MangoButtonedInput,
			IconTimes
		},
		computed: {
			...mapState([ "currentUser", "datetimeMembershipExpire", "isMembershipCancelled" ])
		},
		methods: {
			openPayment() {
				const url = "https://us-central1-mangozpevnik.cloudfunctions.net/createPayment";
				Browser.open({
					url: url
						+ "?email=" + encodeURIComponent(this.currentUser.email)
						+ "&uid=" + encodeURIComponent(this.currentUser.uid)
						+ "&language=" + encodeURIComponent(this.$i18n.locale)
						+ (this.discount ? ("&discount=" + encodeURIComponent(this.discount.code)) : "")
				});
			},
			cancelMembership() {
				if (window.confirm(this.$t('membershipModal.cancelMembershipConfirm'))) {
					const functionCancelMembership = firebase.functions().httpsCallable("cancelMembership");
					functionCancelMembership();
				}
			},
			async useDiscount() {
				const code = this.discountCode.toUpperCase().trim()
				let discount = undefined
				if (code.length > 0) {
					const discountResponse = await firebase.firestore().collection("discounts").doc(code).get()
					discount = discountResponse.data()
				}

				if (discount === undefined) {
					alert("Tento slevový kód není platný. Zkontrolujte prosím jeho správnost.")
				} else {
					this.discount = discount
					this.price = discount.price
				}
			},
			handleBeforeOpen() {
				this.discount = null
				this.discountCode = ""
				if (this.$i18n.locale === "cs") this.price = this.originalPrice = 80
				if (this.$i18n.locale === "en") this.price = this.originalPrice = 6
			}
		}
	}
</script>

<style lang="scss">
	#membership-modal {
		width: 100%;
		height: 100%;
		background-color: #264653;
		color: rgba(255, 255, 255, 0.8);
		font-weight: 300;
		padding-bottom: 15px;

		.close-modal {
			fill: white;
			width: 20px;
			opacity: 0.5;
			position: absolute;
			top: 20px;
			right: 20px;
			cursor: pointer;

			&:hover {
				opacity: 1;
			}
		}

		.discount-input {
			padding: 0 20px;

			p {
				margin: 0 0 20px 0;
			}
		}

		.discount {
			padding: 0 20px;

			p {
				margin: 0 0 20px 0;
			}
		}

		button.payment-button {
			font-weight: 500;
			margin: 5px 20px 15px 20px;
			padding: 0 20px;
			border: 0;
			font-size: 1em;
			line-height: 40px;
			background-color: #ef904e;
			color: rgba(255, 255, 255, 0.75);
			cursor: pointer;
			border-radius: 4px;
			width: 260px;

			&:hover {
				background-color: #d07a46;
			}

			&:focus {
				outline: none;
			}
		}

		button.cancel-membership-button {
			font-weight: 100;
			margin: 5px 20px;
			padding: 0 20px;
			border: 0;
			font-size: 1em;
			line-height: 40px;
			background-color: #356173;
			color: rgba(255, 255, 255, 0.75);
			cursor: pointer;
			border-radius: 4px;
			width: 260px;

			&:hover {
				background-color: #2f4f5f;
			}

			&:focus {
				outline: none;
			}
		}

		h1 {
			margin: 0;
			padding: 20px;
			font-size: 1.4em;
			font-weight: 100;
		}

		p {
			margin: 0 20px 20px 20px;

			a {
				color: rgb(233,196,106);
				text-decoration: underline;

				&:hover {
					color: rgb(211, 177, 97);
				}
			}
		}
	}
</style>
